import React from "react";
import Byd from "../assets/images/Byd.svg";
import Carrefour from "../assets/images/Carrefour.svg";
import Mondelez from "../assets/images/Mondelez.svg";
import Xiaomi from "../assets/images/Xiaomi.svg";
import Suzuki from "../assets/images/Suzuki.svg";
import Zong from "../assets/images/Zong.svg";
import Lottie from "lottie-react";
import rocketAnimation from "../assets/Rocket_2.json";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "./ThirdSec.css";

export const ThirdSection = () => {
  return (
    <div id="projects" className="bg-[#7366fc] py-14">
      <div className="container mx-auto px-4">
        <h3 className="text-center text-white mb-6 font-bold text-lg size-fit mx-auto">
          In Collaboration with
        </h3>
        <div className="thirdSecDiv md:mt-4">
          <Swiper
            data-aos="fade-left"
            slidesPerView={3}
            spaceBetween={10}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            loop={true}
            breakpoints={{
              640: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 6,
                spaceBetween: 50,
              },
            }}
            className="mySwiperThird"
          >
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Byd}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Carrefour}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px] ">
                <img
                  alt={`Company logo`}
                  src={Suzuki}
                  className="object-contain w-full mx-auto"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Mondelez}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px] md:pt-[8px] pt-[3px]">
                <img
                  alt={`Company logo`}
                  src={Xiaomi}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Zong}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Byd}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Carrefour}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px] ">
                <img
                  alt={`Company logo`}
                  src={Suzuki}
                  className="object-contain w-full mx-auto"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Mondelez}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px] md:pt-[8px] pt-[3px]">
                <img
                  alt={`Company logo`}
                  src={Xiaomi}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex-1 max-w-[100px] md:max-w-[150px]">
                <img
                  alt={`Company logo`}
                  src={Zong}
                  className="object-contain w-full"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="mt-6">
          <h4 className=" text-center text-white text-[25px] md:text-[65px] leading-normal md:leading-[40px] mt-6 md:mt-10 font-black tracking-wide  size-fit mx-auto">
            Clean design,
            <span className="md:block hidden"></span>
            <br />
            smooth motion,
            <span className="md:block hidden"></span>
            <br />
            and user flows that,
            <span className="md:block hidden"></span>
            {/* <br /> */}
          </h4>
          <div className="flex justify-center items-center">
            <h4 className="text-center text-white text-[25px] md:text-[65px] leading-normal md:leading-[40px]    font-black tracking-wide">
              <span className="text-[#c0ff00] capitalize ">CONVERTS!</span>
            </h4>
            <Lottie
              animationData={rocketAnimation}
              loop={true}
              autoplay={true}
              className="object-cover h-auto w-[50px] md:w-[120px]"
              // onComplete={onClose}
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-4 justify-center mt-6 ">
          <button
            /* onClick={() => setModalOpen(true)} */
            type="button"
            className="font-semibold uppercase relative rounded-full bg-gray-800 p-1  hover:bg-[#c0ff00] text-[white] hover:text-black hover:border-[#c0ff00] bg-transparent border border-white px-6"
          >
            Meet the Team
          </button>
        </div>
      </div>
    </div>
  );
};
